import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  Link,
} from "@chakra-ui/react";
import Header from "../components/Header";
import { pxToRem } from "../utils/editor.ts";

const PrivacyPolicy: React.FC = () => {
  return (
    <Box h="100%" padding={pxToRem(30)} pt={0}>
      {/* Decorative background elements */}
      <Box
        position="absolute"
        bottom="20%"
        right="10%"
        w={pxToRem(300)}
        h={pxToRem(300)}
        bg="rgba(29, 138, 255, 0.08)"
        borderRadius="full"
        filter={`blur(${pxToRem(80)})`}
        zIndex={0}
      />

      {/* Header with user menu */}
      <Header />

      <Box
        pl={pxToRem(60)}
        pt={pxToRem(20)}
        pb={pxToRem(40)}
        position="relative"
        zIndex={1}
        color={"#000"}
      >
        <VStack align="flex-start">
          <Heading mb={0} as="h1" size="xl">
            Librum Privacy Policy
          </Heading>
          <Text fontSize={"14px"} color="#000">
            Effective Date: 8/18/2025
            <span style={{ marginLeft: pxToRem(80) }}></span>
            Last Updated: 8/18/2025
          </Text>
          <Box overflowY={"auto"} h={"65vh"}>
            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Legal Bases for Processing(GDPR Users))
            </Heading>
            <Text>
              For users in the EU/EEA/UK, we process personal data under these
              legal bases:
            </Text>
            <List styleType="disc" pl={pxToRem(20)}>
              <ListItem>Contract - to provide Services you request.</ListItem>
              <ListItem>
                Consent - for optional features or marketing communications.
              </ListItem>
              <ListItem>Legal obligation - to comply with laws.</ListItem>
              <ListItem>
                Legitimate interests - to improve security, performance, and
                functionality.
              </ListItem>
            </List>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Data Sharing
            </Heading>
            <Text>We may share your data with:</Text>
            <List styleType="disc" pl={pxToRem(20)}>
              <ListItem>
                Service providers - for hosting, payment processing, analytics,
                customer support.
              </ListItem>
              <ListItem>
                Legal authorities - when required by law or to protect rights
                and safety.
              </ListItem>
              <ListItem>
                Business transfers - if we merge, sell, or transfer our assets.
              </ListItem>
            </List>
            <Text>
              We require all service providers to protect your data according to
              this policy.
            </Text>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              International Transfers
            </Heading>
            <Text>
              If you are outside the U.S., your information may be transferred
              to and stored in the U.S. or other countries where our service
              providers operate. We use safeguards such as Standard Contractual
              Clauses for GDPR compliance.
            </Text>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Data Retention
            </Heading>
            <List styleType="disc" pl={pxToRem(20)}>
              <ListItem>
                Account data is kept while your account is active.
              </ListItem>
              <ListItem>
                Upon account deletion, personal data is removed within 30 days,
                except where retention is required by law.
              </ListItem>
              <ListItem>
                Backups may persist for up to 90 days but are securely deleted
                thereafter.
              </ListItem>
            </List>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Your Rights
            </Heading>
            <Text>Depending on your location, you may have rights to:</Text>
            <List styleType="disc" pl={pxToRem(20)}>
              <ListItem>Access, correct, or delete your data.</ListItem>
              <ListItem>Withdraw consent for processing.</ListItem>
              <ListItem>Request data portability.</ListItem>
              <ListItem>Object to certain processing activities.</ListItem>
            </List>
            <Text>
              To exercise these rights, email
              <Link color="blue.500" href="mailto:privacy@doenba.ai">
                privacy@doenba.ai
              </Link>
              . We may verify your identity before fulfilling requests.
            </Text>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Children's Privacy
            </Heading>
            <List styleType="disc" pl={pxToRem(20)}>
              <ListItem>
                We do not knowingly collect data from children under 13 (U.S.
                COPPA) or under the minimum digital consent age in their country
                without parental consent.
              </ListItem>
              <ListItem>
                If we learn a child has provided personal data without consent,
                we will delete it promptly.
              </ListItem>
            </List>
            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Security
            </Heading>
            <Text>
              We use encryption, secure servers, and access controls to protect
              your data. However, no system is 100% secure, and we cannot
              guarantee absolute security.
            </Text>

            <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
              Changes to This Policy
            </Heading>
            <Text>
              We may update this Privacy Policy. If changes are material, we
              will notify you at least 30 days in advance via email or in-app
              notice.
            </Text>

            <Text pt={pxToRem(10)}>
              Contact:
              <Link color="blue.500" href="mailto:support@doenba.ai">
                support@doenba.ai
              </Link>
            </Text>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
